// src/pages/Jobs.jsx
import {
    Container,
    Typography,
    Paper,
    Box,
    Button,
    Stack,
    Grid,
    keyframes,
} from "@mui/material";

import SportsScoreIcon from "@mui/icons-material/SportsScore";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import ComputerIcon from "@mui/icons-material/Computer";
import GroupsIcon from "@mui/icons-material/Groups";

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export default function Jobs() {
    return (
        <Container maxWidth="lg" sx={{ mt: 6, mb: 10 }}>

            {/* HERO */}
            <Box
                sx={{
                    position: "relative",
                    height: { xs: "auto", md: 320 },
                    py: { xs: 6, md: 0 },
                    borderRadius: 3,
                    overflow: "hidden",
                    mb: 10,
                    animation: `${fadeInUp} 0.5s ease-out`,
                }}
            >
                <Box
                    component="img"
                    src="/img_4.png"
                    alt="Chronométrage en montagne"
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        filter: "brightness(0.7)",
                    }}
                />

                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        background:
                            "linear-gradient(135deg, rgba(15,42,74,0.7), rgba(26,77,143,0.4))",
                    }}
                />

                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        textAlign: "center",
                        color: "white",
                        px: 2,
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 700,
                            mb: 1,
                            textShadow: "0 3px 10px rgba(0,0,0,0.4)",
                        }}
                    >
                        Rejoins l’équipe 321‑timing.ch
                    </Typography>

                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 400,
                            opacity: 0.9,
                            textShadow: "0 2px 6px rgba(0,0,0,0.4)",
                        }}
                    >
                        Nous recherchons de nouveaux chronométreurs passionnés.
                    </Typography>
                </Box>
            </Box>

            {/* INTRO */}
            <Box
                sx={{
                    mb: 6,
                    textAlign: "center",
                    animation: `${fadeInUp} 0.7s ease-out`,
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        maxWidth: "720px",
                        margin: "0 auto",
                        color: "text.secondary",
                    }}
                >
                    Que tu sois passionné de sport, de technique ou simplement motivé à
                    rejoindre une équipe dynamique, nous avons une place pour toi.
                </Typography>
            </Box>

            {/* PROFIL RECHERCHÉ */}
            <Grid
                container
                direction="column"
                alignItems="center"
                sx={{
                    width: "100%",
                    maxWidth: 700,
                    margin: "0 auto",
                    px: 2,
                    mb: 8,
                }}
            >
                <Grid item xs={12} sx={{ width: "100%" }}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 4,
                            mb: 4,
                            animation: `${fadeInUp} 0.8s ease-out`,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    backgroundColor: "primary.light",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mr: 2,
                                }}
                            >
                            <SportsScoreIcon sx={{ color: "white" }} />
                        </Box>
                        </Box>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            Profil recherché
                        </Typography>

                        <Stack spacing={1} sx={{ textAlign: "left", color: "text.secondary" }}>
                            <Typography>• Affinité pour le sport et les compétitions.</Typography>
                            <Typography>• Pratiquant·e de sports de neige.</Typography>
                            <Typography>• Intérêt pour la technique et l’informatique.</Typography>
                            <Typography>• Esprit d’équipe, fiabilité et sens du détail.</Typography>
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>

            {/* CE QUE NOUS OFFRONS */}
            <Grid
                container
                direction="column"
                alignItems="center"
                sx={{
                    width: "100%",
                    maxWidth: 700,
                    margin: "0 auto",
                    px: 2,
                    mb: 8,
                }}
            >
                <Grid item xs={12} sx={{ width: "100%" }}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 4,
                            mb: 4,
                            animation: `${fadeInUp} 0.8s ease-out`,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                        backgroundColor: "primary.light",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mr: 2,
                                }}
                            >
                            <AcUnitIcon sx={{ color: "white" }} />
                        </Box>
                        </Box>

                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            Ce que nous offrons
                        </Typography>

                        <Stack spacing={1} sx={{ textAlign: "left", color: "text.secondary" }}>
                            <Typography>• Activité variée lors d’événements sportifs.</Typography>
                            <Typography>• Formation complète aux systèmes de chronométrage.</Typography>
                            <Typography>• Rémunération selon expérience et formation.</Typography>
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>

            {/* POURQUOI NOUS REJOINDRE */}
            <Grid
                container
                direction="column"
                alignItems="center"
                sx={{
                    width: "100%",
                    maxWidth: 700,
                    margin: "0 auto",
                    px: 2,
                    mb: 8,
                }}
            >
                <Grid item xs={12} sx={{ width: "100%" }}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 4,
                            mb: 4,
                            animation: `${fadeInUp} 0.8s ease-out`,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    backgroundColor: "primary.light",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mr: 2,
                                }}
                            >
                            <GroupsIcon sx={{ color: "white" }} />
                        </Box>
                        </Box>

                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            Pourquoi rejoindre 321‑timing.ch ?
                        </Typography>

                        <Typography variant="body1" sx={{ color: "text.", mb: 2 }}>
                            Tu participes à des événements sportifs passionnants, tu découvres les coulisses du chronométrage
                            et tu contribues à la réussite de compétitions locales et internationales.
                        </Typography>

                        <Typography variant="body2" sx={{ fontStyle: "italic", color: "text.secondary" }}>
                            Une expérience unique au cœur du sport et de la technologie.
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>

            {/* CONTACT */}
            <Grid
                container
                direction="column"
                alignItems="center"
                sx={{
                    width: "100%",
                    maxWidth: 700,
                    margin: "0 auto",
                    px: 2,
                    mt: 8,
                }}
            >
                <Grid item xs={12} sx={{ width: "100%" }}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 4,
                            mb: 4,
                            animation: `${fadeInUp} 0.8s ease-out`,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <Box
                                sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    backgroundColor: "primary.light",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mr: 2,
                                }}
                            >
                            <ComputerIcon sx={{ color: "white" }} />
                        </Box>
                        </Box>

                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            Intéressé·e ?
                        </Typography>

                        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
                            Contacte‑nous pour rejoindre notre équipe de chronométreurs passionnés.
                        </Typography>

                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            href="mailto:info@321-timing.ch"
                        >
                            Postuler maintenant
                        </Button>
                    </Paper>
                </Grid>
            </Grid>

        </Container>
    );
}
